module.exports = __webpack_public_path__ + "img/ENDODONCIA_INDICADA.png";